import React from 'react';
import LoaderSpinner from 'react-loader-spinner';
import './style.scss';

interface LoaderProps {
    styles?: {};
    spinnerHeight?: number;
    spinnerWidth?: number;
    color?: string;
}

const Loader = ({ styles, spinnerHeight, spinnerWidth, color = '#6c6c6c90' }: LoaderProps) => (
    <div className="loader-container" style={styles}>
        <LoaderSpinner color={color} height={spinnerHeight || 60} type="TailSpin" width={spinnerWidth || 60} />
    </div>
);

export default Loader;
